import { millisecondsToPaddedTime } from '@packages/utils';

function millisecondsToPaddedTimeFormatter({ value }: { value: number }) {
  return value != null ? millisecondsToPaddedTime(value) : '-';
}

export default millisecondsToPaddedTimeFormatter;
